import SelectStep from './SelectStep'

export default {
    PriceSelectStep: SelectStep('price'),
    WeightSelectStep: SelectStep('weight'),
    QtySelectStep: SelectStep('qty'),
    VolumeSelectStep: SelectStep('volume'),
}
